export default class FormService {
    /**
     * Returns a simple key/value collection of the values of the form's fields
     *
     * @param form
     * @returns
     */
    static getFormValues(form) {
        const values = {};
        for (const item of form.items) {
            if (FormService.isFieldSet(item)) {
                for (const field of item.fields) {
                    values[field.key] = field.value;
                }
            }
            else {
                values[item.key] = item.value;
            }
        }
        return values;
    }
    /**
     * Returns whether the given item is of type FormFieldSetInterface
     *
     * @param item
     * @returns
     */
    static isFieldSet(item) {
        return (item === null || item === void 0 ? void 0 : item.fields) !== undefined;
    }
    /**
     * Returns whether the given field is visible
     *
     * @param fieldSet
     * @param fieldValues
     */
    static isFieldSetVisible(fieldSet, fieldValues) {
        if (!fieldSet.dependencies) {
            return true;
        }
        for (const dependentField in fieldSet.dependencies) {
            const dependentValue = fieldSet.dependencies[dependentField];
            if (dependentValue instanceof RegExp) {
                if (!`${fieldValues[dependentField]}`.match(dependentValue)) {
                    return false;
                }
            }
            else if (fieldValues[dependentField] !== dependentValue) {
                return false;
            }
        }
        return true;
    }
    /**
     * Returns whether the given field is errored
     *
     * @param fieldSet
     * @param validationErrors
     */
    static isFieldSetErrored(fieldSet, validationErrors) {
        for (const field of fieldSet.fields) {
            if (validationErrors[field.key]) {
                return true;
            }
        }
        return false;
    }
    /**
     * Returns whether the given field is visible
     *
     * @param fieldSet
     * @param fieldValues
     */
    static isFieldVisible(field, fieldValues) {
        if (!field.dependencies) {
            return true;
        }
        for (const dependentField in field.dependencies) {
            const dependentValue = field.dependencies[dependentField];
            if (dependentValue instanceof RegExp) {
                if (!`${fieldValues[dependentField]}`.match(dependentValue)) {
                    return false;
                }
            }
            else if (fieldValues[dependentField] !== dependentValue) {
                return false;
            }
        }
        return true;
    }
    /**
     * Returns an MDI icon for an attachment.
     *
     * @param attachment
     */
    static getAttachmentIcon(attachment) {
        if (attachment.mimeType) {
            return FormService.getIconFromMimeType(attachment.mimeType);
        }
        else {
            return FormService.getIconFromExtension(attachment.filename.split('.').pop());
        }
    }
    /**
     * Returns an MDI icon for a mime type.
     *
     * @param mimeType
     */
    static getIconFromMimeType(mimeType) {
        switch (mimeType) {
            case 'application/pdf':
            case 'attachment/pdf':
                return 'mdi-file-pdf';
            case 'audio/aac':
            case 'audio/mpeg':
            case 'audio/mp4':
            case 'audio/ogg':
            case 'audio/vorbis':
            case 'audio/vnd.wav':
            case 'audio/wav':
            case 'audio/webm':
                return 'mdi-file-music';
            case 'application/msword':
            case 'application/rtf':
            case 'application/x-abiword':
            case 'application/vnd.oasis.opendocument.text':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'text/csv':
            case 'text/plain':
                return 'mdi-file-document';
            case 'image/apng':
            case 'image/avif':
            case 'image/bmp':
            case 'image/gif':
            case 'image/jpeg':
            case 'image/png':
            case 'image/svg+xml':
            case 'image/webp':
                return 'mdi-file-image';
            case 'video/mp4':
            case 'video/ogg':
            case 'video/quicktime':
            case 'video/x-msvideo':
            case 'video/x-ms-wmv':
            case 'video/webm':
                return 'mdi-file-video';
            default:
                return 'mdi-file';
        }
    }
    /**
     * Returns an MDI icon for an extension.
     *
     * @param extension
     */
    static getIconFromExtension(extension) {
        switch (extension) {
            case 'pdf':
                return 'mdi-file-pdf';
            case 'aac':
            case 'mp3':
            case 'wav':
            case 'weba':
                return 'mdi-file-music';
            case 'abw':
            case 'csv':
            case 'doc':
            case 'docx':
            case 'odt':
            case 'rtf':
            case 'txt':
                return 'mdi-file-document';
            case 'avif':
            case 'bmp':
            case 'gif':
            case 'jpeg':
            case 'jpg':
            case 'png':
            case 'svg':
            case 'tif':
            case 'tiff':
            case 'webp':
                return 'mdi-file-image';
            case 'avi':
            case 'mp4':
            case 'mpeg':
            case 'mov':
            case 'wmv':
            case 'webm':
                return 'mdi-file-video';
            default:
                return 'mdi-file';
        }
    }
}
//# sourceMappingURL=form-service.js.map